import { useGetUserQuery } from "../../../graphql/generated/graphql";
import { PermissionEnum, hasPermission } from "../../../utils/perms";

export const useAuthorizePermission = (permission: PermissionEnum) => {
  const { data: userData, loading } = useGetUserQuery();
  const userPerms = userData?.user?.role?.permissions;
  const hasPerm = hasPermission(userPerms, permission);
  return { hasPerm, loading };
};
